<template>
  <v-layout>
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        v-if="next_tier && (parseInt(next_tier.condition_type) === 2 || parseInt(next_tier.condition_type) === 3)"
        class="mt-2"
        flat
        :color="theme.bg_color"
      >
      <div :style="cardTitleStyle">
        Membership Upgrade
      </div>
      <div
        style="padding: 10px 10px 10px 10px;border: #9e9e9e solid 1px"
      >
        <div
          v-if="next_tier"
        >
          <div :style="cardTitleStyle">
            {{ next_tier.name }}
          </div>
          <div :style="cardTextStyle">
            {{ getProgress }}
          </div>
          <v-progress-linear
            class="ma-0"
            v-model="upgradeProgress"
            :color="upgradeBarColor"
            height="5"
            background-color="grey lighten-2"
          >
          </v-progress-linear>
          <v-card-text
            class="ma-0 pa-0"
            :style="textStyle"
          >
            {{ next_tier.no_expiry ? '' : getConditionSentence(next_tier) }}
          </v-card-text>
        </div>
      </div>
      </v-card>
      <v-card
        v-else
        class="mt-2"
        flat
        :color="theme.bg_color"
      >
      <div :style="cardTitleStyle">
        Retain Membership
      </div>
      <div
        style="padding: 10px 10px 10px 10px;border: #9e9e9e solid 1px"
      >
        <div
          v-if="current_tier"
        >
          <div :style="cardTitleStyle">
            {{ current_tier.name }}
          </div>
          <div :style="cardTextStyle">
            {{ getExtendProgress }}
          </div>
          <v-progress-linear
            class="ma-0"
            v-model="extendProgress"
            :color="extendBarColor"
            height="5"
            background-color="grey lighten-2"
          >
          </v-progress-linear>
          <v-card-text
            class="ma-0 pa-0"
            :style="textStyle"
          >
            {{ current_tier.no_expiry ? '' : getExtendConditionSentence(current_tier) }}
          </v-card-text>
        </div>
      </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'membership-progress',
  data() {
    return {
      current_tier: null,
      next_tier: null,
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'pictures', 'colors'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('member', [
      'points', 'profile', 'membership', 'membershipConfig'
    ]),
    cardTitleStyle () {
      return {
        fontWeight: 800,
      }
    },
    cardTextStyle () {
      return {
        paddingTop: '0',
      }
    },
    maintainProgress() {
      return this.current_tier.progress_percentage
    },
    maintainBarColor() {
      if (this.current_tier.progress_percentage === 100) {
        return 'green'
      } else if (this.current_tier.progress_percentage > 50) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    upgradeProgress() {
      return this.next_tier.progress_percentage
    },
    upgradeBarColor() {
      if (this.next_tier.progress_percentage >= 100) {
        return 'green'
      } else if (this.next_tier.progress_percentage > 50) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    extendProgress() {
      return this.current_tier.progress_percentage
    },
    extendBarColor() {
      if (this.current_tier.progress_percentage >= 100) {
        return 'green'
      } else if (this.current_tier.progress_percentage > 50) {
        return 'amber'
      } else {
        return 'red'
      }
    },
    textStyle () {
      let color = this.theme.delivery_condition_text_color ? this.theme.delivery_condition_text_color : 'black'
      return {
        color: color,
        fontSize: '12px'
      }
    },
    getProgress() {
      switch (this.next_tier.condition_type){
        case '2':
          return parseInt(this.next_tier.current_progress) > 0 ? 'Amount Spent: $' + this.next_tier.current_progress : ''
        case '3':
          return 'Visit Count: ' + this.next_tier.current_progress
      }
    },
    getExtendProgress() {
      switch (this.current_tier.condition_type){
        case '2':
          return parseInt(this.current_tier.current_progress) > 0 ? 'Amount Spent: $' + this.current_tier.current_progress : ''
        case '3':
          return 'Visit Count: ' + this.current_tier.current_progress
      }
    },
  },
  methods: {
    getConditionSentence(tierCondition) {
      switch (tierCondition.condition_type){
        case '2':
          return parseInt(tierCondition.short) > 0 ? 'Spend $' + tierCondition.short.toFixed(2) + ' or more to upgrade' : ''
        case '3':
          return tierCondition.short + ' or more visits to upgrade'
      }
    },
    getExtendConditionSentence(tierCondition) {
      let expiry = tierCondition.expiry_date ? 'before ' + tierCondition.expiry_date : ''
      switch (tierCondition.condition_type){
        case '2':
          return parseInt(tierCondition.short) > 0 ? 'Spend $' + tierCondition.short.toFixed(2) + ' or more ' + expiry + ' to retain membership tier' : ''
        case '3':
          return tierCondition.short + ' or more visits ' + expiry + ' to retain membership tier'
      }
    }
  },
  async beforeMount () {
    await axios.post('/api/membership/progress', {
      current_rate_id: this.membership.rate_id,
      member_id: this.membership.member_id,
    }).then(response => {
      this.current_tier = response.data.current_tier
      this.next_tier = response.data.next_tier
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/MembershipProgress.vue